import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { AssignedClientsApiService } from 'features/assigned-clients/api/assign-clients-api.service';
import { queryClient } from 'providers';

import { AssignClientsQueryKeys } from './query-keys';
const { DocumentgetUniversalLink } = AssignedClientsApiService();

export const useGetUniversalLink = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: any) => {
      return DocumentgetUniversalLink(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: AssignClientsQueryKeys.all,
        });
      },
    },
  );
};
